import { Link } from '@egw/components'
import { CoreExternalRoutes } from '@egw/constants'
import { Trans, useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { twMerge } from 'tailwind-merge'

export const WealthDisclosuresV3: FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation('features-system')

  const baseClassName = 'w-full flex flex-col gap-sm'

  const finalClassName = twMerge(baseClassName, className)

  return (
    <div data-testid="evergreen-disclosure" className={finalClassName}>
      <p className="typo-primary-sm-light text-text-meta">
        <Trans t={t} i18nKey="wealth_disclosures_yeet_coastal.p_1">
          <Link
            href={CoreExternalRoutes.adv2ABAndCRS_EGW}
            className="cursor-pointer hover:underline inline-flex typo-primary-sm-semibold text-text-action"
          >
            here
          </Link>
        </Trans>
      </p>
      <p className="typo-primary-sm-semibold text-text-meta">{t(`wealth_disclosures_yeet_coastal.p_2`)}</p>
      <p className="typo-primary-sm-light text-text-meta">
        <Trans t={t} i18nKey="wealth_disclosures_yeet_coastal.p_3">
          <Link
            href={CoreExternalRoutes.adv2ABAndCRS_EGW}
            className="cursor-pointer hover:underline inline-flex typo-primary-sm-semibold text-text-action"
          />
        </Trans>
      </p>
      <p className="typo-primary-sm-light text-text-meta">
        <Trans t={t} i18nKey="wealth_disclosures_yeet_coastal.p_4">
          <Link
            href={CoreExternalRoutes.finraBrokerCheck_baseUrl}
            className="cursor-pointer hover:underline inline-flex typo-primary-sm-semibold text-text-action"
          />
        </Trans>
      </p>
      <p className="typo-primary-sm-light text-text-meta">{t(`wealth_disclosures_yeet_coastal.p_5`)}</p>
      <p className="typo-primary-sm-light text-text-meta">{t(`wealth_disclosures_yeet_coastal.p_6`)}</p>
    </div>
  )
}
